import { createContext } from 'react';

const PerspectiveManagerWrapperScrollContext = createContext<() => void>(
  () => {},
);

export default PerspectiveManagerWrapperScrollContext;
